module.exports = __webpack_public_path__ + "static/media/bidules.022a7239.png";